<template>
  <b-modal size="lg" :visible="visible" centered no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header" class="w-100">
      <h5>Saved Cards
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div class="container-fluid">
        <div class="orange card-type-header text-center my-4">Card Type</div>
      <div class="row data-row align-items-center" v-for="token in patientTokens" :key="token.id">
        <div class="col-5 ml-4"></div>
        <div>{{token.cardType}} {{token.last4}}</div>
        <div title="Delete" @click.prevent="deleteToken(token)" type="button" class="btn m-1 wide-button">
          <font-awesome-icon class="orange mr-2 saved-card-delete" :icon="['far', 'trash-alt']"/>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>

  import api from '@/services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'
  import _ from 'lodash'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'card-token-modal',

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      tokens: {
        type: Array,
        required: false
      }
    },

    data () {
      return {
        patientTokens: []
      }
    },

    watch: {
      tokens () {
        this.patientTokens = _.clone(this.$props.tokens)
      }
    },

    methods: {

      closeModal () {
        this.$emit('update:visible', false)
      },

      deleteToken (token) {
        this.errorMessage = ''
        api.delete('/Dashboard/Tokens/' + token.organizationPatientTokenId).then(response => {
          this.patientTokens = response.data
          this.changed = true
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.errors = ['Error deleting organization patient token' + error.message]
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'DeleteOrgPatientToken', error)
          }
        })
      }

    },

    created () {
    }
  }
</script>

<style scoped>

.card-type-header {
  font-weight: bold;
  font-size: 1.2em;
}

.saved-card-delete:hover {
  color: black;
}
</style>
